'use strict';
import {DurationFormatterDirective} from './DurationFormatterDirective';
import {FilterContainerDirective} from './FilterContainerDirective';
import {FilterDialogController} from './FilterDialogController';
const angular = require('angular');

module.exports = angular
  .module('app.core-utilities.filters', [])
  .config(require('./FilterSortingDecorator.js'))
  .factory('BaseFilterMixin', require('./BaseFilterMixinFactory.js'))

  .directive('durationFormatter', DurationFormatterDirective)
  .directive('filterContainer', FilterContainerDirective)
  .directive('filterInput', require('./FilterInputDirective.js'))

  .controller('FilterDialogController', FilterDialogController)
;



// WEBPACK FOOTER //
// ./src/js/core-utilities/filters/index.js